(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cplayer-umd", [], factory);
	else if(typeof exports === 'object')
		exports["cplayer-umd"] = factory();
	else
		root["cplayer-umd"] = factory();
})(window, function() {
return 